/**
 * Iterates over an array of JSON nodes produced from Workflow::Graph.as_json
 * data.nodes must first be precessed by `renderNodes` to ensure they have been
 * prepared for DOM manipulation. Sets the node.element translation style to be
 * the center of the node horizontally and vertically.
 *
 * @param data {object} { roots: [JSON], nodes: [JSON], edges: [JSON], scope: HTMLElement, layout: Layout }
 * @return {object} { roots: [JSON], nodes: [JSON], edges: [JSON], scope: HTMLElement, layout: Layout }
 */
const positionNodes = data => {
  const nodes = data.nodes.map(node => {
    const left = node.x - node.width / 2

    if (node.element) {
      node.element.style.position = "absolute"
      node.element.style.transform = `translate(${left}px, ${node.y}px)`
      node.element.style.margin = 0
      node.element.style.visibility = "visible"
    }

    return node
  })

  return {
    ...data,
    nodes: nodes
  }
}

export default positionNodes
